import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grey-form-card"
}
const _hoisted_2 = { class: "card-parent" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "score-parent"
}
const _hoisted_5 = {
  key: 0,
  class: "score-item"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("h3", { class: "score-header" }, "Predicted MMSE", -1)
const _hoisted_7 = { class: "score-value" }
const _hoisted_8 = {
  key: 1,
  class: "score-item"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("h3", { class: "score-header" }, "Predicted ADAScog", -1)
const _hoisted_10 = { class: "score-value" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_DropdownFilter = _resolveComponent("DropdownFilter")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")

  return (_ctx.state.assessments?.length)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_el_dropdown, {
            class: "input-dropdown",
            trigger: "click",
            placement: "bottom-start"
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_DropdownFilter, {
                    class: "form-dropdown-filter",
                    filterData: _ctx.state.assessmentsObject
                  }, null, 8, ["filterData"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_button, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.getCurrentAssessmentText) + " ", 1),
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.getScores)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                (_ctx.getScores.MMSE)
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _hoisted_6,
                      _createVNode("p", _hoisted_7, _toDisplayString(_ctx.getScores?.MMSE), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.getScores.ADASCog)
                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                      _hoisted_9,
                      _createVNode("p", _hoisted_10, _toDisplayString(_ctx.getScores?.ADASCog), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_11, [
        (_ctx.state.assessments?.length === 0)
          ? (_openBlock(), _createBlock("p", _hoisted_12, "No assessment found"))
          : _createCommentVNode("", true)
      ]))
}